import React from "react";
import { HelpCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { faqs, contact } from "../mock";
import { Link } from "react-router-dom";

const FAQs = () => {
  return (
    <div>
      <section className="relative pt-36 pb-16 bg-[#0a121a] border-b border-white/5 overflow-hidden">
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-64 w-[40rem] rounded-full bg-[var(--gold)]/8 blur-3xl" />
        <div className="relative max-w-4xl mx-auto px-5 text-center">
          <p className="reveal inline-flex items-center gap-2 font-display text-xs uppercase tracking-[0.4em] text-[var(--gold)] mb-4">
            <HelpCircle size={14} /> Good to Know
          </p>
          <h1 className="reveal font-display text-4xl sm:text-6xl font-extrabold text-white">Frequently Asked Questions</h1>
          <p className="reveal mt-5 text-lg text-muted-foreground max-w-2xl mx-auto">Everything you need to know about riding with Shadow Path Services.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-5">
          <Accordion type="single" collapsible className="reveal space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="rounded-xl border border-white/10 bg-[#13212e] px-6 data-[state=open]:border-[var(--gold)]/40 transition-colors">
                <AccordionTrigger className="text-left font-display font-semibold text-white hover:text-[var(--gold)] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="reveal mt-12 rounded-2xl border border-[var(--gold)]/25 bg-[#0a121a] p-8 text-center">
            <h3 className="font-display text-xl font-bold text-white">Still have questions?</h3>
            <p className="mt-2 text-sm text-muted-foreground">Our team is available 24/7 to help you plan the perfect ride.</p>
            <div className="mt-5 flex flex-wrap justify-center gap-3">
              <a href={`tel:${contact.phoneRaw}`} className="btn-ghost-gold rounded-full px-6 py-3 text-sm font-semibold uppercase tracking-widest">Call {contact.phone}</a>
              <Link to="/book" className="btn-gold rounded-full px-6 py-3 text-sm font-semibold uppercase tracking-widest">Book a Ride</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQs;
